import { ReactNode } from "react";

import { Breadcrumbs, BreadcrumbsItem } from "@components/ui/breadcrumb";
import { Skeleton } from "@components/ui/skeleton";

import { cn } from "../utils/ui";

type PageHeaderProps = {
  title: string;
  description?: string;
  breadcrumbs?: BreadcrumbsItem[];
  rightContent?: ReactNode;
  isLoading?: boolean;
};

export const PageHeader = ({
  title,
  description,
  breadcrumbs,
  rightContent,
  isLoading,
}: PageHeaderProps) => {
  return (
    <div
      className={cn("w-full items-start space-y-4", "lg:flex lg:justify-between")}
    >
      <div className="flex-grow space-y-2">
        {isLoading ? (
          <>
            <Skeleton className="h-4 w-1/4" />
            <Skeleton className="h-7 w-3/4" />
            {description && <Skeleton className="h-4 w-2/3" />}
          </>
        ) : (
          <>
            {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
            <h1 className="text-2xl font-bold">{title}</h1>
            {description && (
              <p className="text-sm text-foreground-muted">{description}</p>
            )}
          </>
        )}
      </div>

      {rightContent && <div>{rightContent}</div>}
    </div>
  );
};
